module.exports = __webpack_public_path__ + "img/background_destore.68a1b3a1.svg";